exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-card[data-v-49a40c22]{max-width:500px}", ""]);

// exports
